import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { humanizeFrom, humanizeTo } from '../../shared/tools'
import { model as verifyModel } from '../model'

const ONE_SECOND = 1000
const LIMIT_TIME_TOKEN = 60
type CountdownReturn = {
  liveResendIn: string | null
  liveTo?: string | null
}

export const useCountdown = (): CountdownReturn => {
  const { t } = useTranslation()

  const from = useUnit(verifyModel.$from) // registration uuid request time
  const to = useUnit(verifyModel.$to) // registration uuid end of lifetime
  // ticks
  const [tick, setTick] = useState(0)
  useEffect(() => {
    const timeout = setTimeout(() => setTick((tick) => tick + 1), ONE_SECOND)
    return () => clearTimeout(timeout)
  }, [tick])

  // countdown code expiration
  const [liveTo, setLifeTo] = useState(humanizeTo(to, t))
  useEffect(() => setLifeTo(humanizeTo(to, t)), [to, tick, t])

  // countdown resend request allowance
  const [liveResendIn, setLiveResendIn] = useState(
    humanizeFrom(from, LIMIT_TIME_TOKEN)
  )
  useEffect(
    () => setLiveResendIn(humanizeFrom(from, LIMIT_TIME_TOKEN)),
    [from, tick]
  )

  return { liveTo, liveResendIn }
}
